<p-scrollPanel [style]="{height: 'calc(75vh)'}">
  <div class="payout-row">
      <div class="payout-left">
        <h4 class="text-color">Payout Management</h4>
        <div class="text-theme-color">
          Manage your payout accounts and assign them to different stores.
        </div>
      </div>
      <button class="btn-gray" mat-raised-button (click)="showCreatePaymentMethodDialog()">
        <mat-icon matPrefix>add_circle</mat-icon>
        Add Account
      </button>
    </div>
    <div class="flex-row w-full">
        <div class="col-12 text-center align-content-center h-30rem">
            <img src="/XpressApp/assets/images/partner/onboarding/no_employees.png" class="mb-2" />
            <div class="employee-not-title mb-1">No Payout Account Yet</div>
        </div>
    </div>
</p-scrollPanel>